export interface IApprovedRejectedDistribution {
    colors: string[];
    approvedCount: number;
    approvedAmount: number;
    approvedPercentage: number;
    rejectedCount: number;
    rejectedAmount: number;
    rejectedPercentage: number;
    totalCount: number;
    totalAmount: number;
}

export const emptyApprovedRejectedDistribution: IApprovedRejectedDistribution = {
    colors: [],
    approvedCount: 0,
    approvedAmount: 0,
    approvedPercentage: 0,
    rejectedCount: 0,
    rejectedAmount: 0,
    rejectedPercentage: 0,
    totalCount: 0,
    totalAmount: 0
};
